/* @flow */

import { getEventPlugins } from '@e180/domain/lib/event/util';
import { assertObject } from '@e180/util/lib/assert';

import { slackPlugin } from 'src/shared/app/feature/settings/featureSettings';

import type { BraindateEvent } from '@e180/domain/lib/event/type';

export function getSlackOptions(event: BraindateEvent): ?Object {
  const options = getEventPlugins(event)[slackPlugin];

  if (options) {
    assertObject(options, 'options');

    return options;
  }
}

export function getSlackURL(event: BraindateEvent): ?string {
  return (getSlackOptions(event) || {}).slack_url;
}

export function getSlackChannelName(event: BraindateEvent): ?string {
  return (getSlackOptions(event) || {}).channel_name;
}
